import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DetailsView from '../DetailsView';
import TemplateInputs from '../../../components/admin/forms/contracts/TemplateInputs';
import { MODELS } from '../../../constants/admin/settings';
import { create, update, fetchMember } from '../../../actions/admin/models/templates';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import { Prompt } from 'react-router';
import { editedSelector, formDataSelector, submittingSelector } from '../../../selectors/admin/forms';
import { ARE_YOU_SURE_TEXT } from '../../../constants/texts/errors';
import AdminTabs from '../AdminTabs';
// import TemplateClearing from './TemplateClearing';
import {
    canAccessClearanceInAdminSelector,
    canAccessPerformanceInAdminSelector
} from '../../../selectors/authentication';

class Details extends Component {
    state = { shouldBlockNavigation: false };
    componentDidUpdate() {
        if ((this.props.edited && !this.props.submitting) !== this.state.shouldBlockNavigation) {
            this.setState({ shouldBlockNavigation: this.props.edited && !this.props.submitting });
        }
    }
    render() {
        // const showClearing = this.props.data.type === 'CLEARANCE';
        return (
            <React.Fragment>
                <Prompt when={this.state.shouldBlockNavigation} message={ARE_YOU_SURE_TEXT} />
                <AdminTabs
                    labels={[
                        'General Details'
                        // ...(showClearing && this.props.canAccessClearanceContracts ? ['Default Clearing'] : [])
                    ]}
                    content={[
                        <DetailsView
                            withShowMode={false}
                            model={MODELS.TEMPLATE}
                            fetchModel={this.props.fetchMember}
                            modelId={this.props.match.params.templateId}
                            editView={TemplateInputs}
                            updateAction={this.props.update}
                            createAction={this.props.create}
                            inputData={{
                                canAccessPerformanceContracts: this.props.canAccessPerformanceContracts,
                                canAccessClearanceContracts: this.props.canAccessClearanceContracts,
                                subContext: 'contracts'
                            }}
                        />
                        // REMOVED DUE TO CATEGORIES REWORK
                        // ...(showClearing && this.props.canAccessClearanceContracts
                        //     ? [
                        //           <DetailsView
                        //               withShowMode={false}
                        //               model={MODELS.TEMPLATE}
                        //               fetchModel={this.props.fetchMember}
                        //               modelId={this.props.match.params.templateId}
                        //               editView={TemplateClearing}
                        //               updateAction={this.props.update}
                        //               createAction={this.props.create}
                        //               inputData={{
                        //                   subContext: 'contracts'
                        //               }}
                        //           />
                        //       ]
                        //     : [])
                    ]}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    data: formDataSelector(state, { model: MODELS.TEMPLATE }),
    edited: editedSelector(state),
    canAccessPerformanceContracts: canAccessPerformanceInAdminSelector(state),
    canAccessClearanceContracts: canAccessClearanceInAdminSelector(state),
    submitting: submittingSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ create, update, fetchMember }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withBreadcrumb(Details, () => [BREADCRUMB.CONTRACTS, BREADCRUMB.TEMPLATE_FORM]));
